import { useLocation } from "react-router-dom";

import { RoutePath } from "@mirage/webapp/routeTypes";

export const useChatRoute = () => {
  // return the RoutePath for either the chat page or the standalone chat page depending on the current route
  const { pathname } = useLocation();
  if (pathname.includes(RoutePath.EMBED_CHAT)) {
    return RoutePath.EMBED_CHAT;
  }
  return RoutePath.CHAT;
};
